import SocialLinks from "./SocialLinks";

const Footer = () => (
  <footer style={{ borderTop: "1px solid var(--hairline)" }} data-testid="site-footer">
    <div className="wrap" style={{ padding: "32px 40px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24, flexWrap: "wrap" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        <img src="/assets/rv-monogram-ink.png" alt="RV" style={{ height: 36, width: "auto" }} />
        <span style={{ fontSize: "var(--caption-size)", letterSpacing: "var(--caption-ls)", fontWeight: "var(--weight-thin)", color: "var(--ink-mute)" }}>
          © 2026 Rajesh Vaishnav · rajeshvaishnav.in
        </span>
      </div>
      <SocialLinks size={16} testPrefix="footer-social" />
    </div>
  </footer>
);

export default Footer;
